import React from 'react';
import { StepperPoint } from 'atoms/StepperPoint/StepperPoint';
import { Wrapper, Content, Line, Point } from './styles';

type StepperProps = {
  currentStep: number;
  steps: number;
};

export const OnboardingStepper: React.FC<StepperProps> = ({ steps, currentStep }) => {
  return (
    <Wrapper>
      <Content>
        {Array.from(Array(steps).keys()).map(item => {
          const number = item + 1;
          const focused = number === currentStep;
          const complete = number < currentStep;
          return (
            <Point key={number}>
              <Line focused={focused || complete} />
              <StepperPoint number={number} focused={focused} complete={complete} />
              <Line focused={complete} />
            </Point>
          );
        })}
      </Content>
    </Wrapper>
  );
};
